module.exports = __webpack_public_path__ + "img/heidolph-logo-full.png";